import React from 'react';
import { Link } from 'react-router-dom';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface Props {
  // unique on the page, the tooltip finds the button by it
  id: string;
  icon: IconProp;
  // shown in the tooltip and read by screen readers
  label: string;
  color: 'primary' | 'success' | 'danger' | 'info';
  onClick?: () => void;
  // renders a link instead of a button
  to?: string;
  dataCy?: string;
  // greyed out and not clickable; the tooltip still shows, so `label` can explain why
  locked?: boolean;
}

/** A round, colour filled icon button for table actions. The name of the action shows in a tooltip. */
const IconActionButton: React.FC<Props> = ({ id, icon, label, color, onClick, to, dataCy, locked }) => (
  <>
    <Button
      id={id}
      color={color}
      size="sm"
      className={`icon-action-btn${locked ? ' locked' : ''}`}
      aria-label={label}
      aria-disabled={locked || undefined}
      data-cy={dataCy}
      onClick={locked ? undefined : onClick}
      {...(to && !locked ? { tag: Link, to } : {})}
    >
      <FontAwesomeIcon icon={icon} />
    </Button>
    <UncontrolledTooltip target={id} placement="top" className="icon-action-tooltip">
      {label}
    </UncontrolledTooltip>
  </>
);

export default IconActionButton;
